$(function () {
  const iD = {
    init() {
      iD.create();
    },
    create() {
      const ele = $("[data-bl-details-with-bg]");
      if (ele.length == 0) return;

      iD.calc();

      $(window).on('resize', function() {
        iD.calc();
      });

      $(document).on('click', '.lwptoc_toggle_label', function() {
        setTimeout(function() {
          iD.calc();
        }, 300);
      });
    },
    calc() {
      const ele = $("[data-bl-details-with-bg]");
      const w = $(window).width();

      if (w > 992) {
        ele.each(function() {
          const self = $(this);
          self.find('[data-bl-bg]').css({
            height: ele.height() - ele.find('[data-bl-title]').height() - 60
          });
        });
      }
    }
  };

  iD.init();
});
